import React from 'react'

function Tool_showExtraDataList({extraData}) {
  return (
    <div className='w-100'>
         {extraData.map((extraItem,index) => (
                  <div
                    key={index}
                    className={
                      index === extraData.length - 1
                        ? "w-100 "
                        : "border_under "
                    }
                  >
                    {/*<div className="w-100 d-flex justify-content-between align-items-center m-1">
                      <span className="txtColorBrown py-1">{extraItem.langName}</span>
                      <div className="d-flex justify-content-end flex-wrap w-75">
                        {extraItem.extraOption.map((extraOptionItem,extraOptionItemIndex) => (
                          <div key={extraOptionItemIndex} className="py-1 mr-2 txtColorGray text-nowrap">
                            <span>{extraOptionItem.langName}</span>
                          </div>
                        ))}
                      </div>
                    </div>*/}    
                    <div className="d-flex justify-content-between align-items-center pb-2 my-2">
                      <h5 className="txtColorBrown py-1">{extraItem.langName}</h5>
                      <div className="w-50 d-flex justify-content-end align-items-center">
                        {extraItem.extraOption.map((extraOptionItem,extraOptionItemIndex) => (
                          <div key={extraOptionItemIndex} className="d-flex justify-content-end">
                            <span>{extraOptionItem.langName}</span>
                          </div>
                        ))}
                      </div>
                    </div>               
                  </div>
                ))}
    </div>
  )
}

export default Tool_showExtraDataList